export default __webpack_public_path__ + "static/media/add-patient-icon.1c871068.svg";